<script setup lang="ts">
import { useState } from '#app'
import { computed } from 'vue'
import type { CmsData, CmsText } from '~/layers/cms/app/types/cmsTypes'
import { getByPath } from '../../utils/cmsDataHelper'

const cmsData = useState<CmsData>('cmsData')

if (!cmsData) {
  throw new Error('cmsData not provided')
}

const props = defineProps<{
  cmsDataPath: (string | number)[]
  global?: boolean
}>()

const text = computed(() => {
  return getByPath(cmsData.value, props.cmsDataPath)?.component_data as CmsText
})
</script>

<template>
  <div
    v-cms-text-element="{ path: props.cmsDataPath, global: props.global }"
    v-html="text?.value ?? 'Lorem ipsum'"
  />
</template>
